import _ from 'underscore';

import {redirectTo} from 'BenchlingUtil';
import notifications, {NotificationOptions} from 'notifications';

export const EXPORT_SUCCESS_MESSAGE = 'Export complete. Downloading...';

export interface ExportWithNotificationInput {
  url: string;
  message?: string;
  notificationOptions?: NotificationOptions;
}

export default async function exportWithNotification(
  doExport: () => Promise<ExportWithNotificationInput>
): Promise<void> {
  const notificationId = _.uniqueId('export-');
  notifications.info('Exporting...', {id: notificationId, duration: 0});
  const {url, message, notificationOptions} = await doExport();
  redirectTo(url);
  notifications.success(message ?? EXPORT_SUCCESS_MESSAGE, {
    id: notificationId,
    ...notificationOptions,
  });
}
